/* 
 * This file is created by Vatsaly Patel
 * Note: If you are editing anything, please let me know - or do comment [it's compulsory]
*/

import React, { Component } from "react";
import Label from "../../../components/label";
import AddBankDetailForm from "../../../containers/AddBankDetailsForm";
import appRoutes from "../../../routes/appRoutes";
import { connect } from "react-redux";
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import Model from "../../../components/modal";
import { addBankDetails, getUserProfile } from "../../../apiRoutes";
import MakeAPICall from "../../../apiCalls/common";
import AppConstant from "../../../constants";
import Loader from "../../../components/loader";
import { updateUserData } from "../../../reduxStore/actions/auth";

class AddBankDetailPage extends Component {

  constructor(props) {
    super(props);
    this.state = {
      stripePromise: loadStripe(AppConstant.stripeKey),
      stripeModel: false,
      stripeModelMsg: '',
      apiCall: null,
      apiLoading: false,
    }    
  };

  onAddBankDetailSubmit = async (formValues) => {
    this.setState({
      apiLoading: true
    });

    let convertDate = null, temp = null;
    temp = (this.props.auth.userData.dateOfBirth).split('-');
    convertDate = temp[2] + '-' + temp[1] + '-' + temp[0];

    let formData = new FormData();
    formData.append('stripeToken', formValues.stripeToken);
    formData.append('bankAccountNumber', formValues.bankAccountNumber);
    formData.append('ssn', formValues.ssn);
    formData.append('firstName',  this.props.auth.userData.firstName);
    formData.append('lastName', this.props.auth.userData.lastName);
    formData.append('email', this.props.auth.userData.email);
    formData.append('phoneNumber',  this.props.auth.userData.phoneNumber.startsWith("0") ? "+61" + this.props.auth.userData.phoneNumber.substr(1) : "+61" + this.props.auth.userData.phoneNumber);
    formData.append('dob', convertDate);
    formData.append('postalCode', this.props.auth.userData.address.postCode);
    formData.append('addressLine1', (this.props.auth.userData.address.unitNumber ? this.props.auth.userData.address.unitNumber + '/' : '') + (this.props.auth.userData.address.streetNumber ? this.props.auth.userData.address.streetNumber + ' ' : '') + this.props.auth.userData.address.streetName);
    formData.append('city', this.props.auth.userData.address.suburb);
    formData.append('state', this.props.auth.userData.address.state);
    formData.append('country', 'AU');

    formData.append('routing_number', formValues.routing_number);
    formData.append('account_number', formValues.account_number);
    formData.append('account_holder_name', formValues.account_holder_name);
    formData.append('account_holder_type', formValues.account_holder_type);

    let apiCallParam = {
      reqType: "POST",
      reqURL: addBankDetails,
      dataObj: formData,
      params: {},
      headers: {},
      successCallback: res => {        
        this.updateUserProfile();
      },
      failureCallback: err => {
        console.log("Something went wrong. Please try again ", err);
        this.setState({
          apiLoading: false
        });
      },
      showPopUp: true,
      redirect: appRoutes.bankDetails
    };
    this.setState({
      apiCall: apiCallParam
    });
  };

  setStripeModel = (msg) => {
    this.setState({
      stripeModelMsg: msg,
      stripeModel: true
    });
  };

  closeStripeModel = (msg) => {
    this.setState({
      stripeModel: false
    });
  };

  updateUserProfile = () => {    
    let apiCallParam = {
      reqType: "GET",
      reqURL: getUserProfile,
      dataObj: {},
      params: {},
      headers: {},
      successCallback: res => {  
        let updateManageAc = this.props.auth.userData;
        updateManageAc['manageAccount'] = res.data.data[0].manageAccount;           
        let stateUpdateData = {
          userData : updateManageAc,
          appConstant: this.props.auth.appConstant
        };  
        this.props.updateUserData(stateUpdateData);

        this.setState({
          apiLoading: false
        });
      },
      failureCallback: err => {
        console.log("Something went wrong. Please try again ", err);
        this.setState({
          apiLoading: false
        });
      },
      showPopUp: false
    };
    this.setState({
      apiCall: apiCallParam
    });
    
  }

  render() {
    return (
      <Elements stripe={this.state.stripePromise}>
        <div className="row rounded p-3 bank-edit-page">
          <div className="col-sm-12 p-3">
            <Label title="Add Bank Details" className="big" />
          </div>
          <div className="w-100 border"></div>

          <div className="col-sm-12 mt-4">
            <AddBankDetailForm onFormSubmit={this.onAddBankDetailSubmit} userData={this.props.auth} openStripeModel={this.setStripeModel} />
          </div>
        </div>
        {/* Stripe Error Model */}
        <Model
          openModal={this.state.stripeModel}
          modalBodyContent={this.state.stripeModelMsg}
          okayText="Okay"
          cancelText="Okay"
          title="Instant Consult"
          useOneButton={true}
          okayEvent={this.closeStripeModel}
          cancelEvent={this.closeStripeModel}
        />

        {/* API Call */}
        <MakeAPICall apiParam={this.state.apiCall} />

        
           {/* Loader */}
           <Loader loading={this.state.apiLoading}/>

      </Elements>
    );
  }
}

// export default AddBankDetailPage;

// get the store
const mapStateToProps = props => ({
  auth: props.auth.user
});

const mapDispatchToProps = dispatch => ({
  updateUserData: (data) => dispatch(updateUserData(data))
});

export default connect(mapStateToProps, mapDispatchToProps)(AddBankDetailPage);

